import { render } from "./BookingFormFlight.vue?vue&type=template&id=1e06d55b"
import script from "./BookingFormFlight.vue?vue&type=script&lang=js"
export * from "./BookingFormFlight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__